import {defineStore} from 'pinia';
import {ref} from 'vue';

export const useVideoStore = defineStore('video', () => {
    const isMuted = ref(true);
    const videos = ref<HTMLVideoElement[]>([]);

    const toggleMuteAll = () => {
        isMuted.value = !isMuted.value;
    };

    const registerVideo = (video: HTMLVideoElement) => {
        videos.value.push(video);
    };

    const unregisterVideo = (video: HTMLVideoElement) => {
        videos.value = videos.value.filter(v => v !== video);
    };

    return {
        isMuted,
        toggleMuteAll,
        registerVideo,
        unregisterVideo,
    };
});
